import '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import _default from '@angular/common/locales/es-CO';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DaliModule } from '@dali/tagger-ng8';
import { VoxelLoggerModule } from '@voxel/logger';
import { SegmentTypes, VoxelConfigModule } from '@voxel/mobile';
import { NativeAnalyticsObject, NativeObject, VoxelNativeCommunicationModule } from '@voxel/native-communication';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { loadResources } from './app.config';
import { CaptureModule } from './pages/capture/capture.module';
import { ConfigurationModule } from './pages/configuration/configuration.module';
import { IdentificationModule } from './pages/identification/identification.module';
import { ProductSelectionModule } from './pages/product-selection/product-selection.module';
import { SharedModule as SharedModulePages } from './pages/shared/shared.module';
import { SignOnModule } from './pages/sign-on/sign-on.module';
import { SharedComponentsModule } from './shared/components/shared-components.module';
import { NumberPipe } from './shared/pipe/number.pipe';
import { StringFormatPipe } from './shared/pipe/string.format.pipe';
import {
  CipherCommunicatorService,
} from './shared/services/communicator/platform-communicator/cipher-communicator/cipher-communicator.service';
import {
  CryptoVaultCipherCommunicatorService,
} from './shared/services/communicator/platform-communicator/cipher-communicator/crypto-vault-cipher-communicator.service';
import { CopyService } from './shared/services/copies/copy.service';
import { LoanModule } from './pages/multiproducto/loan/loan.module';
import { ParametersService } from './shared/services/parameters/parameters.service';
import {
  MockService,
  PlatformCommunicatorInterceptor,
  PlatformCommunicatorService,
  PlatformEndpointService,
  SharedModule,

} from './shared/shared.module';
import { AbreCuentasModel } from './shared/models/abre-cuentas.model';
import { ShowcasesDealsModule } from './pages/showcases-deals/showcases-deals.module';
import { AdjustEvent } from './shared/services/external/adjust/adjust.service';
import { SpecialOfferModel } from './shared/models/specialOffer/special-offer.model';

// tslint:disable-next-line
registerLocaleData(_default, 'es-CO');

@NgModule({
  declarations: [
    AppComponent,
    NumberPipe,
    StringFormatPipe,
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    VoxelConfigModule.forRoot({
      production: environment.production,
      segment: SegmentTypes.Varejo,
    }),
    VoxelLoggerModule.forRoot({
      production: environment.production,
      applicationName: 'onboarding-angular-fe',
    }),
    VoxelNativeCommunicationModule,
    SharedModule,
    SharedComponentsModule,
    ProductSelectionModule,
    IdentificationModule,
    ShowcasesDealsModule,
    DaliModule,
    CaptureModule,
    ConfigurationModule,
    SignOnModule,
    SharedModulePages,
    SignOnModule,
    LoanModule,
  ],
  providers: [
    {
      provide: NativeObject,
      useValue: environment.sdkObjectMock,
    },
    AbreCuentasModel,
    SpecialOfferModel,
    AdjustEvent,
    {
      provide: NativeAnalyticsObject,
      useValue: environment.analyticsObjectMock,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-CO',
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadResources,
      multi: true,
      deps: [
        MockService,
        PlatformEndpointService,
        ParametersService,
        CopyService,
        PlatformCommunicatorService,
      ],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PlatformCommunicatorInterceptor,
      multi: true,
    },
    CipherCommunicatorService,
    {
      provide: CipherCommunicatorService,
      useClass: CryptoVaultCipherCommunicatorService,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class AppModule { }
